import React from 'react';
import { QuizPage } from '../components/QuizPage';
export function Revenue({
  onAnswer
}: {
  onAnswer: (ans: string, dq: boolean) => void;
}) {
  return <QuizPage stepNumber={2} question="What's your CURRENT monthly revenue?" options={[{
    label: 'Under $40K',
    isDq: true
  }, {
    label: '$40-60K'
  }, {
    label: '$60-80K'
  }, {
    label: '$80K+'
  }]} onSelect={opt => onAnswer(opt.label, !!opt.isDq)} data-id="element-162" />;
}